export const DOCUMENT_CREATED_DATE_FORMAT = 'M/d/yy';
